
  <div class="container-fluid text-center footer">
    <img class="align-items-md-center" src="../../../../assets/images/ordem/u2.png"/>
    <div class="row">
      <div class="col-12">
            <div class="container">

                <div class="row">
                    <div class="col-6 text-sm-left text-footer">
                      <p>Serasa Experian - São Paulo</p>
                      <p>Alameda dos Quinimuras, 187, Planalto Paulista, CEP 04068-900, São Paulo, SP</p>
                      <p>CNPJ 62.173.620/0001-80</p>
                      <br><br>

                      <p>Serasa Experian - São Carlos</p>
                      <p>Av. Doutor Heitor José Reali, 360, CEP 13571-385 - São Carlos, SP</p>
                      <p>CNPJ 62.173.620/0093-06</p>
                    </div>
                  <div class="col-6 text-right text-footer">
                    
                    <img src="../../../../assets/images/ordem/u7.png">
                    <p>©2017 Experian Information Solutions, Inc. Experian Marketing Services All rights reserved</p>
                    <p>Experian and the Experian marks used herein are service marks or registered trademarks of Experian Informations </p>
                    <p>Solutions, Inc. Other product and company names mentioned herein are the property of their respective owners.</p>
                  </div>
                </div>
            </div>
      </div>
    </div>
  </div>
